import React, { useState } from 'react'
import notification from '../../../assets/images/dashboard/header/bell.svg'
import arrow from '../../../assets/images/dashboard/header/doenArrow.svg'
import Ongoing from '../../../assets/images/dashboard/body/recicle.svg'
import Completed from '../../../assets/images/dashboard/body/tick.svg'
import Pending from '../../../assets/images/dashboard/body/timer.svg'
import Rejected from '../../../assets/images/dashboard/body/crose.svg'
import search from "../../../assets/images/dashboard/body/Search.svg"
import OrganizationAddTaskModal from '../../ui/OrganizationAddTaskModal'
import img from "../../../assets/images/img.svg"
import FindCategory from '../../ui/FindCategory'
import CustomDatePicker from '../../ui/CustomDatePicker'

const VolunteerDashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [filterCategoryModal, setFilterCategoryModal] = useState(false);
  const toggleFilterCategoryModal = () => setFilterCategoryModal(!filterCategoryModal);
  const closeFilterCategoryModalModal = () => {
    setFilterCategoryModal(false);
  };

  const [datePickerModal, setDatePickerModal] = useState(false);
  const toggleDatePickerModal = () => setDatePickerModal(!datePickerModal);
  const closeDatePickerModal = () => {
    setDatePickerModal(false);
  };

  const insightsData = [
    { title: 'Ongoing', count: '00', icon: Ongoing, bgColor: '#0A3400', borderColor: '#0A3400', color: "#D6FACD" },
    { title: 'Pending', count: '00', icon: Pending, bgColor: '#6EAB5E', borderColor: '#0A3400', color: "#D6FACD" },
    { title: 'Completed', count: '00', icon: Rejected, bgColor: '#D6FACD', borderColor: '#0A3400', color: "#0A3400" },
    { title: 'Rejected', count: '00', icon: Completed, bgColor: '#FF4161', borderColor: '#0A3400', color: "#FFEBEF" },
  ];

  const challengesData = [
    { status: 'Active', taskName: 'Task Name Here', volunteers: 'Jenna K., Sam S.', duration: 'March 12-March 20', deadline: '4 Days' },
    { status: 'In Progress', taskName: 'Task Name Here', volunteers: 'Murry M.', duration: 'March 12-March 20', deadline: '4 Days' },
    { status: 'Active', taskName: 'Task Name Here', volunteers: 'Jenna K.', duration: 'March 12-March 20', deadline: '17 Days' },
    { status: 'Active', taskName: 'Task Name Here', volunteers: 'Sam S., Murry M.', duration: 'March 12-March 20', deadline: '3 Days' },
    { status: 'In Progress', taskName: 'Task Name Here', volunteers: 'Jenna K.', duration: 'March 12-March 20', deadline: '2 Days' },
  ];

  const couponsData = [
    {
      status: 'Available',
      name: 'Coupon Name',
      description: '2 Tickets to see Wicked on Broadway',
      expiresIn: 'March 12-March 20',
    },
    {
      status: 'In Progress',
      name: 'Coupon Name',
      description: 'New Nikes',
      expiresIn: 'March 12-March 20',
    },
    {
      status: 'Expired',
      name: 'Coupon Name',
      description: 'Sip and Shop Experience',
      expiresIn: 'March 12-March 20',
    },
    {
      status: 'Available',
      name: 'Coupon Name',
      description: '$10 to Good & Gather Coffee Shop',
      expiresIn: 'March 12-March 20',
    },
    {
      status: 'Used',
      name: 'Coupon Name',
      description: '$10 to Good & Gather Coffee Shop',
      expiresIn: 'March 12-March 20',
    },
    {
      status: 'Available',
      name: 'Coupon Name',
      description: '2 Tickets to see Wicked on Broadway',
      expiresIn: 'March 12-March 20',
    },

  ];


  return (
    <div className=''>
      <div className='hidden lg:flex py-4 lg:pr-10 bg_header border-b-2 border-[#362269]'>
        <div className='relative hidden lg:flex items-center pl-8'>
          <input type="search" placeholder='Search' className='min-w-[625px] h-8 border-0 rounded-lg' />
          <img src={search} alt="search" className='absolute right-[15px] top-[10px] ' />
        </div>

        <div className='hidden md:flex ml-auto items-center'>
          <span className='w-8 h-8  rounded-full'><img src={img} alt="img" /></span>

          <div className='flex items-center'>
            <p className='pl-3 font-bold'>Volunteer</p>
          </div>

          <img src={notification} alt="notification" className='pl-4 text-black' />
        </div>

      </div>

      <div className='dashboard_header relative px-4 xl:px-0 '>

        <div className='circle_design'></div>

        <div className='xl:w-[85%] mx-auto mb-[30px] mt-[50px] hidden lg:flex items-center justify-between'>

          <b className='font_family'>Total Challenges</b>

          <div className='flex'>
            <button onClick={toggleModal} className='ml-auto w-[112px] h-[40px] text-[10px] rounded-xl flex justify-center items-center border  border-gray-300 bg-[#D6FACD] text-[#362269]'>
              Add Task
            </button>

            <button onClick={toggleDatePickerModal} className="w-[112px] h-[40px] border flex justify-center items-center border-gray-300 ml-2 bg-[#D6FACD] text-[10px] py-1 px-2 rounded-xl">
              Filter by date
              <img src={arrow} alt="arrow" className='w-[10px] h-auto p-[1px] ml-1' />
            </button>
          </div>
        </div>

        {isModalOpen && (
          <div
            id="default-modal"
            tabIndex="-1"
            aria-hidden={!isModalOpen}
            className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
            onClick={toggleModal}
          >
            <div
              className="relative p-4 w-full max-w-xl max-h-full rounded-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <OrganizationAddTaskModal onLogin={closeModal} />
            </div>
          </div>
        )}

        <div className='xl:w-[90%] mx-auto '>

          {datePickerModal && (
            <div
              id="default-modal"
              tabIndex="-1"
              aria-hidden={!isModalOpen}
              className="ml-auto w-fit fixed right-10 top-30 bg-white pb-64 p-4 rounded-lg"
              onClick={toggleDatePickerModal}
            >
              <div
                className="relative  p-4 max-w-full max-h-full rounded-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <CustomDatePicker onLogin={closeDatePickerModal} />

                <button className='absolute right-[-8px] top-[-8px] text-black' onClick={toggleDatePickerModal}>
                  &#10006;
                </button>
              </div>
            </div>
          )}

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-6">
            {insightsData.map((card, index) => (
              <div
                key={index}
                className="p-4 mb-4 lg:mb-0 rounded-2xl flex flex-col min-w-[195px] h-[124px] items-center shadow-md mx-auto"
                style={{ backgroundColor: card.bgColor, color: card.color, borderColor: card.borderColor, borderWidth: '1px', borderStyle: 'solid' }}
              >
                <span className="text-4xl"><img src={card.icon} alt="img" /></span>
                <h3 className="text-lg font-bold mt-1 font_family">{card.title}</h3>
                <p className="text-[29.5px] font-bold font_family">{card.count}</p>
              </div>
            ))}
          </div>

          <div className='xl:w-[95%] mx-auto'>
            <b className='font_family '>Active challenges</b>

            <div className='grid lg:grid-cols-2 gap-2 mt-2' >
              <div className='flex h-[32px] gradient1 border border_dark justify-between items-center rounded-lg px-4'>
                <p>Task Name Here</p>

                <b className='text-2xl font_family text-[#D6FACD]'>33%</b>
              </div>

              <div className='flex h-[32px] gradient2 border border_dark justify-between items-center rounded-lg px-4'>
                <p>Task Name Here</p>

                <b className='text-2xl font_family text-[#D6FACD]'>5%</b>
              </div>

              <div className='flex h-[32px] gradient3 border border_dark justify-between items-center rounded-lg px-4'>
                <p>Task Name Here</p>

                <b className='text-2xl font_family text-[#D6FACD]'>80%</b>
              </div>

              <div className='flex h-[32px] gradient4 border border_dark justify-between items-center rounded-lg px-4'>
                <p>Task Name Here</p>

                <b className='text-2xl font_family text-[#D6FACD]'>50%</b>
              </div>
            </div>
          </div>

          <div className="my-6 lg:m-6 border border_dark rounded-lg bg-[#F6F2EF]">
            <div className="flex justify-between items-center border-b-2 border_dark p-3 rounded-t-lg">
              <b className='font_family'>Ongoing Tasks</b>

              <button
                onClick={toggleFilterCategoryModal}
                className="border ml-auto flex justify-center items-center border-gray-300 bg-[#D6FACD] w-[112px] h-[40px] text-[10px] rounded-xl"
              >
                Filter by Category
                <img src={arrow} alt="arrow" className="w-[10px] h-auto p-[1px] ml-1" />
              </button>

              {filterCategoryModal && (
                <div
                  id="category-modal"
                  tabIndex="-1"
                  aria-hidden={!filterCategoryModal}
                  className="fixed inset-0 z-50 flex justify-center items-center bg-gray-900 bg-opacity-50"
                  onClick={closeFilterCategoryModalModal}
                >
                  <div
                    className="relative w-full max-w-xl max-h-full rounded-lg"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FindCategory onLogin={closeFilterCategoryModalModal} />
                  </div>
                </div>
              )}
            </div>

            <div className="overflow-x-auto">
              <table className="font_ovo min-w-full border-2 border_dark rounded-t-lg overflow-hidden whitespace-nowrap">
                <thead className="border-2 border-[#0A3400] font_family">
                  <tr>
                    <th className="text-left border-2 border_dark p-4 md:px-4 md:py-2"></th>
                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm text-green-900">STATUS</th>
                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm text-green-900">TASK NAME</th>
                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm text-green-900">VOLUNTEERS</th>
                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm text-green-900">DURATION</th>
                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm text-green-900">DEADLINE</th>
                  </tr>
                </thead>

                <tbody>
                  {challengesData.map((challenge, index) => (
                    <tr key={index} className="border-2 border-[#0A3400]">
                      <td className={`p-4 md:px-4 md:py-2 border-2 border_dark ${index % 2 === 0 ? 'bg-[#0A3400]' : 'bg-[#D6FACD]'}`}></td>
                      <td className="p-2 sm:text-base text-sm md:px-4 md:py-2 text-green-900 border-2 border_dark">{challenge.status}</td>
                      <td className="p-2 sm:text-base text-sm md:px-4 md:py-2 border-2 border_dark">{challenge.taskName}</td>
                      <td className="p-2 sm:text-base text-sm md:px-4 md:py-2 border-2 border_dark">{challenge.volunteers}</td>
                      <td className="p-2 sm:text-base text-sm md:px-4 md:py-2 border-2 border_dark">{challenge.duration}</td>
                      <td className="p-2 sm:text-base text-sm md:px-4 md:py-2 border-2 border_dark">{challenge.deadline}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>


            <div className="flex bg-[#D6FACD] justify-center items-center border_dark border-t-2 rounded-b-lg">
              <button className="font-bold text-black w-full h-10 flex items-center justify-center text-2xl">
                +
              </button>
            </div>
          </div>




        </div>

        <div className="my-16 mx-auto lg:w-[85%] border border_dark bg-[#F6F2EF] rounded-lg overflow-hidden">
          <div className="flex justify-between items-center border-b-2 border_dark p-3 rounded-t-lg">
            <b className="font_family text-purple-900">Task History</b>

            <button
              onClick={toggleFilterCategoryModal}
              className="border flex justify-center items-center border-gray-300 bg-[#C6AFFF] w-[112px] h-[40px] text-[10px] rounded-xl"
            >
              View Report
              <img src={arrow} alt="arrow" className="w-[10px] h-auto p-[1px] ml-1" />
            </button>

            {filterCategoryModal && (
              <div
                id="category-modal"
                tabIndex="-1"
                aria-hidden={!filterCategoryModal}
                className="fixed inset-0 z-50 flex justify-center items-center bg-gray-900 bg-opacity-50"
                onClick={closeFilterCategoryModalModal}
              >
                <div
                  className="relative w-full max-w-xl max-h-full rounded-lg"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FindCategory onLogin={closeFilterCategoryModalModal} />
                </div>
              </div>
            )}
          </div>

          <div className="overflow-x-auto">
            <table className="font_ovo min-w-full rounded-lg whitespace-nowrap">
              <thead className="text-[#362269] font-bold font_family">
                <tr>
                  <th className="text-left border-2 border_dark md:px-4 md:py-2"></th>
                  <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">STATUS</th>
                  <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">COUPON NAME</th>
                  <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">DESCRIPTION</th>
                  <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">DATE</th>
                </tr>
              </thead>

              <tbody>
                {couponsData.map((coupon, index) => (
                  <tr key={index} className="border-2 border_dark">
                    {/* Status column with conditional coloring */}
                    <td
                      className={`px-4 py-2 border-2 border_dark font-bold text-white ${coupon.status === 'Expired'
                        ? 'bg-[#FF4161]'
                        : coupon.status === 'In Progress'
                          ? 'bg-[#FF889C]'
                          : coupon.status === 'Used'
                            ? 'bg-[#362269]'
                            : 'bg-green-300'
                        }`}
                    ></td>

                    <td className="p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm text-purple-900 hover:underline cursor-pointer">
                      {coupon.status}
                    </td>

                    <td className="p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm text-purple-900 hover:underline cursor-pointer">
                      {coupon.name}
                    </td>

                    <td className="p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm text-gray-700">{coupon.description}</td>

                    <td className={`p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm ${coupon.status === 'Expired' ? 'text-red-500' : ''}`}>
                      {coupon.expiresIn}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center items-center border_dark border-t-2 rounded-b-lg">
            <button className="bg-[#C6AFFF] font-bold text-black w-full h-10 flex items-center justify-center text-2xl">
              +
            </button>
          </div>
        </div>

      </div>
    </div>
  )
}

export default VolunteerDashboard